module.exports = "pegasus/assets/email1-company-logo4.png";